// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
/* ===== HERO CARD – IMAGE MATCH ===== */
.section-home-banner {
  /* Welcome text */
  /* NO. 1 */
  /* Subtitle */
}
.section-home-banner .slider-text-box {
  color: #111 !important;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;
  backdrop-filter: none !important;
  -webkit-backdrop-filter: none !important;
  border-radius: 15px;
}
.section-home-banner .header-welcome {
  font-size: 16px !important;
  font-weight: 500;
  margin-bottom: 15px;
}
.section-home-banner .header-welcome .header-welcome-text {
  font-size: 18px !important;
  font-weight: 500;
  line-height: 1.4;
}
.section-home-banner .header-welcome .header-welcome-icon img {
  height: 42px;
}
.section-home-banner .hero-title {
  display: flex;
  align-items: baseline;
  gap: 12px;
  margin: 10px 0 8px;
}
.section-home-banner .no-text {
  font-size: 50px;
  font-weight: 700;
  color: #fff;
}
.section-home-banner .no-number {
  font-family: "Georgia", "Times New Roman", serif;
  font-size: 100px;
  font-weight: 800;
  line-height: 1;
  color: #fff;
}
.section-home-banner .hero-subtitle {
  font-size: 36px;
  font-weight: 700;
  line-height: 1.25;
  margin-top: 5px;
  min-height: 95px;
}`, "",{"version":3,"sources":["webpack://./src/app/home/home.component.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB,wCAAA;AACA;EAUI,iBAAA;EAiBA,UAAA;EAsBA,aAAA;AA5CJ;AAHI;EACI,sBAAA;EACA,qDAAA;EACA,gCAAA;EACA,wCAAA;EACA,mBAAA;AAKR;AADI;EACI,0BAAA;EACA,gBAAA;EACA,mBAAA;AAGR;AADQ;EACI,0BAAA;EACA,gBAAA;EACA,gBAAA;AAGZ;AAAQ;EACI,YAAA;AAEZ;AAGI;EACI,aAAA;EACA,qBAAA;EACA,SAAA;EACA,kBAAA;AADR;AAII;EACI,eAAA;EACA,gBAAA;EACA,WAAA;AAFR;AAKI;EACI,gDAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,WAAA;AAHR;AAOI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;EACA,gBAAA;AALR","sourcesContent":["/* ===== HERO CARD – IMAGE MATCH ===== */\n.section-home-banner {\n\n    .slider-text-box {\n        color: #111 !important;\n        box-shadow: 0 8px 30px rgba(0, 0, 0, 0.12) !important;\n        backdrop-filter: none !important;\n        -webkit-backdrop-filter: none !important;\n        border-radius: 15px;\n    }\n\n    /* Welcome text */\n    .header-welcome {\n        font-size: 16px !important;\n        font-weight: 500;\n        margin-bottom: 15px;\n\n        .header-welcome-text {\n            font-size: 18px !important;\n            font-weight: 500;\n            line-height: 1.4;\n        }\n\n        .header-welcome-icon img {\n            height: 42px;\n        }\n    }\n\n    /* NO. 1 */\n    .hero-title {\n        display: flex;\n        align-items: baseline;\n        gap: 12px;\n        margin: 10px 0 8px;\n    }\n\n    .no-text {\n        font-size: 50px;\n        font-weight: 700;\n        color: #fff;\n    }\n\n    .no-number {\n        font-family: \"Georgia\", \"Times New Roman\", serif;\n        font-size: 100px;\n        font-weight: 800;\n        line-height: 1;\n        color: #fff;\n    }\n\n    /* Subtitle */\n    .hero-subtitle {\n        font-size: 36px;\n        font-weight: 700;\n        line-height: 1.25;\n        margin-top: 5px;\n        min-height: 95px;\n    }\n\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
